import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ServiceplanComponent } from './serviceplan.component';

const routes: Routes = [ { path: '', component: ServiceplanComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServiceplanRoutingModule { }
